import { render, staticRenderFns } from "./CreateLead.vue?vue&type=template&id=06c8938d"
import script from "./CreateLead.vue?vue&type=script&lang=ts"
export * from "./CreateLead.vue?vue&type=script&lang=ts"
import style0 from "./CreateLead.vue?vue&type=style&index=0&id=06c8938d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports